import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useMeteringRecord} from '../hooks/useMeteringRecord.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: meteringRecordId} = useParams();

    if (typeof meteringRecordId === 'undefined') {
        throw new Error('meteringRecordId is required parameter');
    }

    const {
        record: meteringRecord,
        updateRecord,
        loading,
    } = useMeteringRecord(meteringRecordId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !meteringRecord) {
        return <PlatformLoader message='Loading meteringRecord...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={meteringRecord.productCode ? meteringRecord.productCode : meteringRecord.id}
            pageNavigation={<EditPageNavigation component={meteringRecord}/>}
            tools={tools}
        >

            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={meteringRecord}
                    />
                </Stack>
                :
                <RecordForm
                    record={meteringRecord}
                    handleSubmit={updateRecord}
                />}

        </FormPageLayout>
    );
};
